import { useMemo } from 'react';
import { SwiperSlide } from 'swiper/react';

import ArticleCard from '@components/cards/ArticleCard';
import styles from '@components/explore/Explore.module.css';
import CardSlides from '@components/layout/CardSlides';
import { EventTypeEnum } from '@typing/Enums';
import { GetArticlesBasicQuery } from '@typing/Generated';
import { sortByTimestamp } from '@utils/modelUtils';

type Article = NonNullable<NonNullable<NonNullable<GetArticlesBasicQuery['articles']['edges']>[number]>['node']>;

type Props = {
  eventType: EventTypeEnum | undefined;
  journeyId: string;
  webinars: Article[];
};

const Events = ({ eventType, journeyId, webinars }: Props) => {
  const webinarsGrouped = useMemo(
    () => ({
      past: webinars.filter(webinar => webinar.webinarCompleted),
      upcoming: sortByTimestamp(
        webinars.filter(webinar => !webinar.webinarCompleted),
        webinar => webinar.webinarStartTime
      ).reverse()
    }),
    [webinars]
  );

  return (
    <div>
      <div className={styles.hideMobile}>
        <div
          className={
            webinarsGrouped.upcoming.length > 0 && eventType !== EventTypeEnum.PAST ? styles.eventsUpcoming : 'ion-hide'
          }
        >
          {webinarsGrouped.upcoming.map(webinar => (
            <ArticleCard article={webinar} journeyId={journeyId} key={webinar.id} />
          ))}
        </div>

        <div className={eventType !== EventTypeEnum.UPCOMING ? styles.eventsPast : 'ion-hide'}>
          {webinarsGrouped.past.map(webinar => (
            <ArticleCard article={webinar} journeyId={journeyId} key={webinar.id} />
          ))}
        </div>
      </div>

      <div className={styles.showMobile}>
        <div
          className={
            webinarsGrouped.upcoming.length > 0 && eventType !== EventTypeEnum.PAST ? styles.eventsUpcoming : 'ion-hide'
          }
        >
          <CardSlides itemCount={webinarsGrouped.upcoming.length}>
            {webinarsGrouped.upcoming.map(webinar => (
              <SwiperSlide key={webinar.id}>
                <ArticleCard article={webinar} journeyId={journeyId} />
              </SwiperSlide>
            ))}
          </CardSlides>
        </div>

        <div className={eventType !== EventTypeEnum.UPCOMING ? styles.eventsPast : 'ion-hide'}>
          <CardSlides itemCount={webinarsGrouped.past.length}>
            {webinarsGrouped.past.map(webinar => (
              <SwiperSlide key={webinar.id}>
                <ArticleCard article={webinar} journeyId={journeyId} />
              </SwiperSlide>
            ))}
          </CardSlides>
        </div>
      </div>
    </div>
  );
};

export default Events;
